module.exports = {
  SUGGEST: 'ott/common/suggest',
  SUGGEST_FAIL: 'ott/common/suggestFail',
  SUGGEST_SUCCESS: 'ott/common/suggestSuccess',
  SUGGEST_RESET: 'ott/common/suggestReset',
};
